export default {
    getErrorStatusCode(state) {
        return state.status
    }
}